import { Component } from '@angular/core';

/**
 * Renders the OIDC callback route (`/sso/callback`).
 *
 * Authorization code processing and the Ping → Okta → /login-error fallback
 * are handled in `AppComponent.handleAuthFallback()`, which runs after
 * `checkAuthMultiple()` resolves and has access to the per-config auth results.
 * By that point the library has already stripped the callback query params from
 * the URL via `history.replaceState`, so this component has no further role.
 */
@Component({
  selector: 'app-sso-callback',
  standalone: true,
  template: ``,
  styles: [],
})
export class SsoCallbackComponent {}
